/*
*	Typographie.js, v1.0.1
*	(c) 2014–2017 Artyom "Sleepwalker" Fedosov <mail@asleepwalker.ru>
*	https://github.com/asleepwalker/typographie
*/

import 'core-js/fn/array/includes.js';
import 'core-js/fn/map.js';

export {default} from './typographie.js';



// WEBPACK FOOTER //
// ./src/index.js